export default __webpack_public_path__ + "static/media/Ilustrai_LSP_3 _1.71331a67.svg";